<template>
  <section class="grid-view">
    <home-loader v-if="loader" />
    <b-row v-else>
      <b-col
        v-if="isEditAble"
        md="10"
        offset-md="1"
        sm="12"
      >
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="12">
                <b-alert
                  variant="info"
                  show
                >
                  <div class="alert-body">
                    <feather-icon
                      icon="InfoIcon"
                      class="mr-50"
                    />
                    {{
                      $t('Campaigns is for sending bulk message to group contacts.if contacts count more than messages sending limit per day , messages will send next day at selected time.')
                    }}
                  </div>
                </b-alert>
                <b-alert
                  variant="danger"
                  show
                >
                  <h4 class="alert-heading">
                    <feather-icon
                      size="18"
                      icon="AlertTriangleIcon"
                      class="mr-50"
                    />
                    <span>{{ $t('Warning') }}</span>
                  </h4>
                  <div class="alert-body">
                    {{
                      $t('Sending messages with a new account, high number of messages, aimless messages, etc. in campaigns will most likely lead to the blocking of your account (by WhatsApp).')
                    }}
                  </div>
                </b-alert>
                <b-alert
                  variant="warning"
                  show
                >
                  <h4 class="alert-heading">
                    <feather-icon
                      size="18"
                      icon="AlertTriangleIcon"
                      class="mr-50"
                    />
                    <span>{{ $t('Attention') }}</span>
                  </h4>
                  <div class="alert-body">
                    {{
                      $t('Campaigns are sent with specific timing between each message, about 7 messages are sent every minute, calculate the approximate time of the end of the messages so that the message reaches the audience on time and avoids sending messages at inappropriate times.')
                    }}
                  </div>
                </b-alert>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <b-card>
          <b-card-title v-if="id">
            {{ $t('Edit Campaign') }} {{ name }}
          </b-card-title>
          <b-card-body>
            <form-wizard
              color="#28c76f"
              :title="null"
              :subtitle="null"
              :finish-button-text="$t('Save')"
              :back-button-text="$t('Previous')"
              :next-button-text="$t('Next')"
              :hide-buttons="spin"
              class="steps-transparent mb-3"
              @on-complete="saveCampaign"
            >
              <!--   CAMPAIGN NAME   /-->
              <tab-content
                :title="$t('Campaign name')"
                icon="feather icon-file-text"
                :before-change="validationCampaignName"
              >
                <validation-observer
                  ref="saveCampaignName"
                  #default="{ invalid }"
                >
                  <b-row class="match-height">
                    <b-col
                      cols="12"
                      class="mb-2"
                      md="6"
                      sm="12"
                    >
                      <h5 class="mb-1">
                        {{ $t('Campaign name') }}
                      </h5>
                      <p>
                        {{ $t('Campaign name details') }}
                      </p>
                    </b-col>
                    <b-col
                      cols="12"
                      class="mb-2"
                      md="6"
                      sm="12"
                    >
                      <b-row>
                        <b-col
                          md="12"
                        >
                          <b-form-group>
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('Campaign name')"
                              vid="name"
                              rules="required"
                            >
                              <b-form-input
                                id="name"
                                v-model="name"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :placeholder="$t('Campaign name')"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          md="12"
                        >
                          <b-form-group>
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('Accounts')"
                              vid="Accounts"
                              rules="required"
                            >
                              <v-select
                                v-model="selectedAccount"
                                label="name"
                                :options="accounts"
                                :state="errors.length > 0 ? false : null"
                                :placeholder="$t('Accounts')"
                              >
                                <template #option="{ name }">
                                  <span> {{ name }}</span>
                                </template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                              <small class="text-success">{{
                                $t('Select one account to send messages')
                              }} ...</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>

                  </b-row>
                </validation-observer>
              </tab-content>
              <!--            CAMPAIGN Contacts                /-->
              <tab-content
                :title="$t('Campaign contacts')"
                icon="feather icon-file-text"
                :before-change="validationCampaignContacts"
              >
                <validation-observer
                  ref="saveCampaignContacts"
                  #default="{ invalid }"
                >
                  <b-row class="match-height">
                    <b-col
                      cols="12"
                      md="6"
                      sm="12"
                      class="mb-2"
                    >
                      <h5 class="mb-1">
                        {{ $t('Campaign contacts') }}
                      </h5>
                      <p>
                        {{ $t('Campaign contacts details') }}
                      </p>
                    </b-col>
                    <b-col
                      md="6"
                      sm="12"
                    >
                      <b-row>
                        <b-col
                          md="12"
                          class="mb-2"
                        >
                          <b-form-group>
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('Group')"
                              rules="required"
                              vid="Group"
                            >
                              <v-select
                                v-model="selectedGroup"
                                label="name"
                                :options="groups"
                                multiple
                                :state="errors.length > 0 ? false : null"
                                :placeholder="$t('Group')"
                              >
                                <template #option="{ text,value,contact }">
                                  <div
                                    class="d-flex align-items-center w-100"
                                    style="width: 100%"
                                  >{{ text }}({{ contact }})
                                  </div>
                                </template>
                                <template #selected-option="{ text,value,contact }">
                                  {{ text }}({{ contact }})
                                </template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                              <small
                                class="text-success"
                              >{{ $t('You can select contact of groups hear') }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          v-if="maxSend > 0 && messageCount > 0"
                          md="6"
                          class="mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <span class="mr-1">{{ $t('Unsent Contacts count') }} :  </span>
                            <b-badge variant="success">
                              {{ messageCount }}
                              <feather-icon
                                icon="MessageSquareIcon"
                                class="ml-1"
                              />
                            </b-badge>

                          </div>
                        </b-col>
                        <b-col
                          v-if="maxSend > 0 && messageCount > 0"
                          md="6"
                          class="mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <span class="mr-1">{{ $t('Message balance') }} : </span>
                            <b-badge :variant="lackOfMessage ? 'danger' : 'success'">
                              {{ service.total_messages }}
                              <feather-icon
                                icon="MessageSquareIcon"
                                class="ml-1"
                              />
                            </b-badge>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row v-if="lackOfMessage">
                        <b-col
                          md="12"
                          class="mb-1"
                        >
                          <b-alert
                            v-ripple
                            show
                            variant="danger"
                          >
                            <div class="alert-body">
                              <feather-icon
                                icon="InfoIcon"
                                class="mr-50"
                              />
                              {{ $t('Your message balance is not enough to send this number of contacts') }}
                            </div>
                          </b-alert>
                        </b-col>
                      </b-row>
                      <b-row v-else>
                        <b-col
                          class="mb-2"
                          md="4"
                        >
                          <b-form-group :label="$t('Scheduled')">
                            <b-form-checkbox
                              v-model="scheduled"
                              checked="false"
                              class="custom-control-success"
                              name="check-button"
                              switch
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          class="mb-2"
                          md="4"
                        >
                          <b-form-group
                            v-if="scheduled"
                            :label="$t('Send date')"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('Send date')"
                              vid="sendDate"
                              :rules="sendDateRules"
                            >
                              <date-picker
                                v-model="sendDate"
                                format="YYYY-MM-DD HH:mm"
                                display-format="jYYYY/jMM/jDD HH:mm"
                                :state="errors.length > 0 ? false : null"
                                :placeholder="$t('Send date')"
                                type="datetime"
                                custom-input=".date-time-autochat"
                                :min="moment().format('YYYY-MM-DD HH:mm')"
                                color="#28c76f"
                              />
                              <b-input-group>
                                <b-input-group-prepend is-text>
                                  <feather-icon icon="CalendarIcon" />
                                </b-input-group-prepend>
                                <b-form-input
                                  class="date-time-autochat"
                                  style="direction: ltr"
                                  :value="localeDateTime(sendDate)"
                                />
                              </b-input-group>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          v-if="!lackOfMessage"
                          class="mb-2"
                          md="4"
                        >
                          <b-form-group
                            :label="$t('limit per day')"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('limit per day')"
                              vid="limit_per_day"
                              :rules="`required|integer|max_value:${maxSend}`"
                            >
                              <b-input-group>
                                <b-input-group-prepend is-text>
                                  <feather-icon icon="MessageSquareIcon" />
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="sendPerDay"
                                  type="number"
                                  :value="sendPerDay"
                                  :max="maxSend"
                                />
                              </b-input-group>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          v-if="showDescription"
                          md="12"
                          class="mb-1"
                        >
                          <b-alert
                            v-ripple
                            show
                            variant="warning"
                          >
                            <div class="alert-body">
                              <feather-icon
                                icon="InfoIcon"
                                class="mr-50"
                              />
                              {{ $t('Campaign schedule description',{name:name,date:localeDateTime(sendDate),count:sendingToday,end_date:localeDateTime(endDate)}) }}
                              <strong v-if="messageCount > sendPerDay">
                                {{ $t('Campaign schedule description pending',{count:messageCount - sendPerDay}) }}</strong>
                            </div>
                          </b-alert>
                        </b-col>
                      </b-row>
                    </b-col>

                  </b-row>
                </validation-observer>
              </tab-content>
              <!--              Campaign Messages                  -->
              <tab-content
                :title="$t('Campaign messages')"
                icon="feather icon-file-text"
                :before-change="validationCampaignMessages"
              >
                <validation-observer
                  ref="saveCampaignMessages"
                  #default="{ invalid }"
                >
                  <b-row class="match-height">
                    <b-col
                      cols="12"
                      class="mb-2"
                      md="6"
                      sm="12"
                    >
                      <h5 class="mb-1">
                        {{ $t('Campaign messages') }}
                      </h5>
                      <p>
                        {{ $t('Campaign messages details') }}
                      </p>
                      <b-card
                        v-if="fileSrc !== null && fileSrc !==''"
                        no-body
                      >
                        <b-card-title>{{ $t(`${messageType.value} Message`) }}</b-card-title>
                        <b-card-body
                          v-if="fileLoader"
                          class="d-flex justify-content-center"
                        >
                          <b-spinner />
                        </b-card-body>
                        <b-card-body v-else>
                          <video
                            v-if="messageType.value ==='video'"
                            :src="fileSrc"
                            width="100%"
                            controls
                          >
                            <source
                              :src="fileSrc"
                            >
                            Your browser does not support the video tag.
                          </video>
                          <b-img
                            v-else-if="messageType.value ==='image'"
                            :src="fileSrc"
                            fluid
                          />
                          <audio
                            v-else-if="messageType.value ==='audio'"
                            size="100%"
                            :src="fileSrc"
                            controls
                          />
                          <div v-else>
                            {{ fileSrc }}
                          </div>
                        </b-card-body>
                      </b-card>
                    </b-col>
                    <b-col
                      md="6"
                      sm="12"
                    >
                      <b-row>
                        <b-col
                          md="12"
                        >
                          <b-form-group>
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('Message type')"
                              vid="messageType"
                              rules="required"
                            >
                              <v-select
                                v-model="messageType"
                                label="text"
                                :options="messageTypes"
                                :state="errors.length > 0 ? false : null"
                                :placeholder="$t('Message type')"
                              >
                                <template #option="{ text,value,icon }">
                                  <feather-icon
                                    :icon="icon"
                                    size="16"
                                    :value="value"
                                    class="align-middle mr-50"
                                  />
                                  <span> {{ text }}</span>
                                </template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                              <small
                                class="text-success"
                              >{{ $t('Message type like text , image,video and') }} ...</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group v-if="messageType && messageType.value !=='text'">
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('file')"
                              vid="file"
                              :rules="fileRules"
                            >
                              <b-form-file
                                v-model="file"
                                :accept="messageType.attachment"
                                :placeholder="$t('Choose a file or drop it here')"
                                :drop-placeholder="$t('Drop file here')"
                              />
                              <b-card-text
                                v-if="file !== null"
                                class="my-1"
                              >
                                {{ $t('Selected file') }} : <strong>{{
                                  file.name | summaryText(60)
                                }}</strong><br><strong>{{ $t('File size') }} : {{ file.size | humanFileSize }}</strong>
                              </b-card-text>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>

                        <b-col
                          md="12"
                        >
                          <div v-if="showMessageText">
                            <b-form-group>
                              <validation-provider
                                #default="{ errors }"
                                :name="$t('message text')"
                                vid="message"
                                rules="required"
                              >
                                <b-input-group :prepend="$t('message text')">
                                  <b-form-textarea
                                    id="message-text"
                                    v-model="message"
                                    :state="errors.length > 0 ? false : null"
                                  />
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                                <campaign-message-helper />
                              </validation-provider>
                            </b-form-group>
                            <b-form-group :label="$t('Cancel text')">
                              <b-form-checkbox
                                v-model="cancelText"
                                checked="true"
                                class="custom-control-success"
                                name="check-button"
                                switch
                              />
                              <small
                                class="text-success"
                              >{{ $t('Cancel text helper') }}</small>
                            </b-form-group>
                          </div>

                          <b-alert
                            v-else-if="messageType.value ==='image' || messageType.value ==='video'"
                            variant="danger"
                            show
                          >
                            <div class="alert-body">
                              <feather-icon
                                icon="InfoIcon"
                                class="mr-50"
                              />
                              {{ $t(`Message ${messageType.value} send as file`) }}
                            </div>
                          </b-alert>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row v-if="spin && file !== null">
                    <b-col cols="12">

                      <b-progress
                        :value="fileProgress"
                        rtl
                        max="100"
                        :precision="2"
                        show-value
                        variant="primary"
                        class="progress-bar-primary"
                      />
                    </b-col>
                  </b-row>
                </validation-observer>
              </tab-content>
            </form-wizard>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        v-else
        md="10"
        offset="1"
        sm="12"
      >
        <b-card-body>
          <b-row>
            <b-col md="12">
              <b-alert
                variant="danger"
                show
              >
                <div class="alert-body">
                  <feather-icon
                    icon="InfoIcon"
                    class="mr-50"
                  />
                  {{ $t('Campaign') }} {{ name }} {{ $t('Can not be edited') }}
                </div>
              </b-alert>
            </b-col>
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import * as moment from 'jalali-moment'
import { FormWizard, TabContent } from 'vue-form-wizard'
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BFormFile,
  BCardBody,
  BCardText,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BFormGroup,
  BFormTextarea,
  BBadge,
  BFormCheckbox,
  BImg,
  BAlert,
  BSpinner,
  BProgress,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  required, fileSize, image, ext, integer, max_value,
} from '@validations'
import CampaignMessageHelper from '../../components/campaigns/edit/CampaignMessageHelper'
import HomeLoader from '../../components/loaders/HomeLoader'
import { localeDateTime } from '../../common/utils/utils'

export default {
  components: {
    HomeLoader,
    CampaignMessageHelper,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BBadge,
    BFormFile,
    BInputGroup,
    BFormInput,
    BCardTitle,
    BInputGroupPrepend,
    BFormGroup,
    BFormTextarea,
    BAlert,
    BFormCheckbox,
    FormWizard,
    TabContent,
    BImg,
    BSpinner,
    BProgress,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loader: true,
      spin: false,
      campaign: {},
      name: '',
      message: '',
      accounts: [],
      selectedAccount: [],
      service: {},
      maxSend: 0,
      isEditAble: true,
      sendPerDay: 0,
      maxMessagePerMinute: 7,
      scheduled: false,
      cancelText: true,
      sendDate: moment().format('YYYY-MM-DD HH:mm'),
      filePath: '',
      messageType: {
        value: 'text',
        icon: 'FileTextIcon',
        text: this.$t('text'),
        attachment: '',
      },
      selectedGroup: [],
      file: null,
      fileSrc: null,
      fileLoader: false,
      fileProgress: 0,
      maxImageSize: 5242880,
      maxVideoSize: 8388608,
      sendAsFile: false,
      messageTypes: [
        {
          value: 'text',
          icon: 'FileTextIcon',
          text: this.$t('text'),
        },
        {
          value: 'image',
          icon: 'ImageIcon',
          text: this.$t('image'),
          attachment: 'image/jpeg,image/png,image/jpg',
          validation: 'image:jpeg,png,jpg|file-size:30',
        },
        {
          value: 'video',
          icon: 'VideoIcon',
          text: this.$t('video'),
          attachment: 'video/mp4, video/3gpp',
          validation: 'ext:mp4,3gpp|file-size:30',
        },
        {
          value: 'audio',
          icon: 'Volume2Icon',
          text: this.$t('audio'),
          attachment: 'audio/aac, audio/mp4, audio/amr, audio/mpeg,audio/ogg; codecs=opus|file-size:30',
        },
        {
          value: 'file',
          icon: 'FilePlusIcon',
          text: this.$t('file'),
          attachment: 'file-size:50',
        },
      ],
      messageCount: 0,
      groups: [],
      localeDateTime,
      required,
      moment,
      fileSize,
      image,
      ext,
      integer,
      max_value,
    }
  },
  computed: {
    showMessageText() {
      return this.messageType && this.messageType.value !== 'audio' && this.messageType.value !== 'file' && !this.sendAsFile
    },
    showDescription() {
      return this.name !== '' && this.sendPerDay > 0 && this.messageCount > 0 && this.selectedGroup && this.selectedAccount
    },
    sendingToday() {
      if (this.messageCount > this.sendPerDay) {
        return this.sendPerDay
      }
      return this.messageCount
    },
    endDate() {
      const minutes = Math.floor(this.sendingToday / this.maxMessagePerMinute)

      return moment(this.sendDate).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm')
    },
    lackOfMessage() {
      return this.service.total_messages < this.messageCount
    },
    sendDateRules() {
      if (this.scheduled) return 'required'
      return ''
    },
    fileRules() {
      let rules = this.messageType.validation
      if (this.messageType.value !== 'text' && (!this.file && !this.campaign.file)) {
        rules += '|required'
      }
      return rules
    },
  },
  watch: {
    file: 'fileChanged',
    messageType: 'messageTypeChanged',
    selectedGroup: 'calculateMessageCount',
    selectedAccount: 'changedAccount',
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      if (this.id !== null) {
        this.$http
          .get(`campaigns/${this.id}/edit`)
          .then(({ data }) => {
            this.campaign = data.campaign
            this.name = this.campaign.name
            this.selectedAccount = this.campaign.account
            this.maxSend = this.campaign.account.limit_per_day
            this.sendPerDay = this.campaign.limit_per_day
            this.scheduled = this.campaign.status === 'scheduled'
            this.cancelText = this.campaign.cancel_text
            this.sendDate = this.campaign.send_at
            this.messageTypes.forEach(messageType => {
              if (messageType.value === this.campaign.message_type) this.messageType = messageType
            })
            this.selectedGroup = this.campaign.groups
            this.filePath = this.campaign.file
            this.fileSrc = this.campaign.file_url
            this.message = this.campaign.message
            this.messageCount = this.campaign.message_count
            this.isEditAble = this.campaign.editAble
            this.calculateMessageCount()
            this.groups = data.groups
            this.accounts = data.accounts
            this.service = data.service
            this.loader = false
          })
          .catch(() => {
          })
      } else {
        this.$http
          .get('campaigns/create')
          .then(({ data }) => {
            this.groups = data.groups
            this.accounts = data.accounts
            this.loader = false
          })
          .catch(() => {
          })
      }
    },
    saveCampaign() {
      const groups = this.selectedGroup.map(value => value.id)
      const formData = new FormData()
      let config = {}
      formData.append('name', this.name)
      formData.append('account_id', this.selectedAccount.id)
      formData.append('groups', groups.join(','))
      formData.append('limit_per_day', this.sendPerDay)
      formData.append('scheduled', this.scheduled)
      formData.append('cancel_text', this.cancelText === true ? 1 : 0)
      formData.append('send_at', this.sendDate)
      formData.append('message_type', this.messageType.value)
      formData.append('message', this.message)

      if (this.file !== null) {
        formData.append('file', this.file)
        config = {
          onUploadProgress: progressEvent => {
            this.fileProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            )
          },
        }
      }
      let url = 'campaigns'
      if (this.id !== null) {
        url += `/${this.id}`
        formData.append('_method', 'PUT')
      }
      this.spin = true
      this.$http.post(url, formData, config).then(({ data, message }) => {
        this.$router
          .replace({ name: 'campaigns-show', params: { id: data.id } })
          .then(() => {
            this.showSuccessNotification(message)
            this.spin = false
          })
      })
        .catch(() => {
          this.spin = false
        })
    },
    messageTypeChanged() {
      this.sendAsFile = false
      this.file = null
    },
    changedAccount() {
      this.maxSend = this.selectedAccount?.limit_per_day
      this.$http
        .get(`services/${this.selectedAccount.service_id}`)
        .then(({ data }) => {
          this.service = data
        })
        .catch(() => {
        })
      // this.sendPerDay = this.maxSend
    },
    calculateMessageCount() {
      this.messageCount = 0
      this.maxSend = this.selectedAccount?.limit_per_day
      if (this.sendPerDay === 0) {
        this.sendPerDay = this.maxSend
      }
      this.selectedGroup.forEach(group => {
        this.messageCount += group.contact
      })
    },
    validationCampaignName() {
      return new Promise((resolve, reject) => {
        this.$refs.saveCampaignName.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationCampaignContacts() {
      return new Promise((resolve, reject) => {
        this.$refs.saveCampaignContacts.validate().then(success => {
          if (success && !this.lackOfMessage) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationCampaignMessages() {
      return new Promise((resolve, reject) => {
        this.$refs.saveCampaignMessages.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    fileChanged(file) {
      if (file !== null) {
        const type = file.type.split('/')[0]
        const { size } = file
        if (type === 'image') {
          this.sendAsFile = size > this.maxImageSize
          const fr = new FileReader()
          fr.onloadstart = () => {
            this.fileLoader = true
          }
          fr.onload = () => {
            this.fileSrc = fr.result
          }
          fr.onloadend = () => {
            this.fileLoader = false
          }
          fr.readAsDataURL(file)
        } else if (type === 'video' || type === 'audio') {
          if (this.fileSrc !== null) URL.revokeObjectURL(this.fileSrc)
          this.fileLoader = true
          this.sendAsFile = size > this.maxVideoSize
          this.fileSrc = URL.createObjectURL(file)
          this.fileLoader = false
        }
      }
    },
  },
}
</script>
<style lang="scss">
html[dir=rtl] .vue-form-wizard .wizard-card-footer .wizard-footer-right .wizard-btn:after{
    display: none;
}
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
